var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPenEditCircle = function SvgPenEditCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m8.624 14.379 3.02-.373a.96.96 0 0 0 .56-.274l7.317-7.31c.81-.811.81-2.125 0-2.936v0a2.076 2.076 0 0 0-2.935 0l-7.248 7.249a.959.959 0 0 0-.271.542z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.02 3.832a8.15 8.15 0 1 0 8.15 8.15M17.76 8.173l-2.934-2.935"
  })));
};
export { SvgPenEditCircle as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmY4NTZhZmQ4NGQ0Y2ZhOTk4MmM5NGI1NzE1MGU5NDkuc3ZnIjs=";